export default "__VITE_ASSET__DPdqPth9__"